<template>
  <v-app>
    <!-- Main -->
    <v-main>
      <v-container fluid class="fill-height login-bg">
        <slot transition="slide-y-transition"></slot>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  created () {
    this.$vuetify.theme.dark = this.info.theme_login_variant === 'dark'
  },
  computed: {
    ...mapGetters({
      info: ['App/info']
    }),
    year () {
      return new Date().toLocaleString(window.navigator.language, {
        year: 'numeric'
      })
    }
  }
}
</script>

<style scoped>
.login-bg {
  background: #ffffff url("../../assets/bg_login.jpg") no-repeat fixed center !important;
}
</style>
